import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "../stylesheets/resource.scss";
import axios from "axios";
import {
	NoDataIndication,
	Loader,
	tableStyle,
	mystyle,
	dateCol,
	AllocateTeam,
	ProjectStatus,
} from "../ticketModule/variables/ListingVariables";
import { Project_APIs } from "./Project_APIs";
import { UserConsumer } from "../../UserContext";
import { goBackFunction } from "../../utils";
import { Redirect } from "react-router-dom";
import FormStatus from "../../components/FormStatus";
import { Routes } from "../../configurations/config";
let token = null;
class ProjectHistory extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			projectId: "",
			allocateTo: [],
			projectDetails: {},
			error: null,
			isLoaded: false,
			tableLoader: false,
			projectName: "",
			items: [],
			toggledClearRows: false,
			uniqueId: 1,
			columns: [
				{
					dataField: "projectName",
					text: "Project Name",
					sort: true,
				},
				{
					dataField: "projectType",
					text: "Project Type",
					sort: true,
					headerStyle: {
						width: "15%",
					},
				},
				{
					dataField: "supervisorName",
					text: "Supervisor",
					sort: true,
					formatter: (cell, row) => {
						return row.supervisorName === null
							? "N/A"
							: row.supervisorName;
					},
					headerStyle: {
						width: "16%",
					},
				},
				{
					dataField: "allocateTo",
					text: "Team",
					formatter: AllocateTeam,
				},
				{
					dataField: "projectStatus",
					text: "status",
					sort: true,
					formatter: ProjectStatus,
					headerStyle: {
						width: "12%",
					},
				},
				{
					dataField: "createdAt",
					text: "Create Date",
					sort: true,
					formatter: dateCol,
					headerStyle: {
						width: "13%",
					},
				},
			],
		};
	}
	goBack = () => {
		goBackFunction(Routes.ProjectListing, this.props.history);
	};
	componentDidMount() {
		const headers = {
			Authorization: `Bearer ${token}`,
		};
		this.setState({ tableLoader: true }, () => {
			axios
				.get(
					`${Project_APIs.ProjectHistory_API}${this.props.match.params.projectId}`,
					{
						headers: headers,
					}
				)
				.then((res) => {
					const projects = [];
					const teams = [];

					res.data.forEach(({ allocateTo, projectDetails }) => {
						projectDetails.allocateTo = allocateTo;
						projects.push(projectDetails);
						teams.push(projects);
					});
					this.setState({
						items: projects,
						tableLoader: !this.state.tableLoader,
					});
				});
		});
	}

	expandRow = {
		showExpandColumn: true,
		expandByColumnOnly: true,
		onlyOneExpanding: true,
		className: "expandingRow",
		renderer: (cell, row) => (
			<div>
				<label htmlFor="p1" style={mystyle}>
					Project Name
				</label>
				<p id="p1">{cell.projectName}</p>
				<label htmlFor="p7" style={mystyle}>
					Project's DevOps Name
				</label>
				<p id="p7">
					{cell.devopsProjectName ? cell.devopsProjectName : "N/A"}
				</p>
				<label htmlFor="p8" style={mystyle}>
					Project's DevOps Area path
				</label>
				<p id="p8">
					{cell.devopsAreaPath ? cell.devopsAreaPath : "N/A"}
				</p>
				<label for="p2" style={mystyle}>
					Project Type
				</label>
				<p id="p2">
					{cell.projectType === null ? "N/A" : cell.projectType}
				</p>
				<label for="p3" style={mystyle}>
					Supervisor
				</label>
				<p id="p3">
					{cell.supervisorName === null ? "N/A" : cell.supervisorName}
				</p>
				<label for="p4" style={mystyle}>
					Team
				</label>
				<p id="p4">
					{cell.allocateTo.map((allocateTo, index) => (
						<span key={index}>
							{(index ? "\xa0\xa0,\xa0\xa0" : "") +
								allocateTo.name}
						</span>
					))}
				</p>
				<label for="p5" style={mystyle}>
					Project Status
				</label>
				<p id="p5">{cell.ProjectStatus === 0 ? "Inctive" : "Active"}</p>
				<label for="p7" style={mystyle}>
					Notes
				</label>
				<p id="p7">{cell.notes === "" ? "N/A" : cell.notes}</p>
				<label for="p6" style={mystyle}>
					Update Date
				</label>
				<p id="p6">{new Date(cell.createdAt).toDateString()}</p>
			</div>
		),
	};
	defaultSorted = [
		{
			dataField: "projectHistoryId",
			order: "desc",
		},
	];
	render() {
		return (
			<UserConsumer>
				{(userDetails) => {
					token = userDetails.token;

					return userDetails.designation.toString() === "4" ||
						userDetails.id.toString() === "180" ||
						userDetails.id.toString() === "269" ? (
						<ToolkitProvider
							keyField="projectHistoryId"
							bootstrap4
							data={this.state.items}
							columns={this.state.columns}
							search
						>
							{(props) => (
								<div className="container-fluid pl-4 pr-4">
									<FormStatus
										title={
											this.props.history.location
												? this.props.history.location
														.state.projectName
												: "Project History"
										}
										className="create-request d-flex align-items-center"
										onClick={this.goBack}
										navigateBack={true}
									/>

									<BootstrapTable
										classes="table-sm table-borderless  table-responsive-md table-responsive-lg table-responsive-sm table-responsive-xl "
										rowStyle={tableStyle}
										headerClasses="header-class"
										expandRow={this.expandRow}
										bordered={false}
										{...props.baseProps}
										hover={true}
										defaultSorted={this.defaultSorted}
										noDataIndication={() =>
											this.state.tableLoader ? (
												<NoDataIndication />
											) : (
												<Loader />
											)
										}
									/>
								</div>
							)}
						</ToolkitProvider>
					) : (
						<Redirect to="/MyDashboard" />
					);
				}}
			</UserConsumer>
		);
	}
}
export default ProjectHistory;
